<template>
    <div>
        <Menu/>
        <SubmitOrder
            :couponList="couponList"
            :order="order"
            :cartIdList="[]"
        />
        <Footer/>
    </div>
</template>

<script>
    import SubmitOrder from "@/components/Order/SubmitOrder";
    import {goodsCouponsList} from "@/api/coupons";
    import Menu from "@/components/Menu.vue";
    import Footer from "@/components/Footer.vue";

    export default {
        data() {
            return {
                goodsInfo: {},
                goodsType: 0,
                couponList: [],
                order:{
                    amount:0,
                    orderItems:[],
                },
            }
        },
        components: {
            SubmitOrder,
            Menu,
            Footer,
        },
        created() {
            let params = this.$route.query;
            this.goodsInfo = JSON.parse(params.goodsInfo);
            this.goodsType = params.goodsType;
            this.order.amount=this.goodsInfo.user_sales_price;
            this.order.orderItems.push(this.goodsInfo);

            this.fetchGoodsCouponList();
        },

        methods: {
            fetchGoodsCouponList() {
                const params = {
                    id: this.goodsInfo.id,
                    type: this.goodsType,
                    use_status: 0,
                    page: 1,
                    pageSize: 1000,
                };
                goodsCouponsList(params).then(rep => {
                    if (rep !== -1) {
                        this.couponList = rep.data;
                    }
                });
            },
        },


    }
</script>
